import request from '@/router/axios';

export const add = (row) => {
  return request({
    url: '/api/produce/truck-transport-plan/insert',
    method: 'post',
    data: row
  })
}
export const update = (row) => {
  return request({
    url: '/api/produce/truck-transport-plan/update',
    method: 'post',
    data: row
  })
}
export const getDetail = (id) => {
  return request({
    url: '/api/produce/truck-transport-plan/getById',
    method: 'get',
    params: {
      id
    }
  })
}
export const getList = (data) => {
  return request({
    url: '/api/produce/truck-transport-plan/selectPage',
    method: 'post',
    data
  })
}

/** 导出 Excel（筛选条件与列表查询一致，服务端生成） */
export const exportExcel = (params) => {
  return request({
    url: '/api/produce/truck-transport-plan/export/excel',
    method: 'post',
    data: params,
    responseType: 'blob'
  })
}
export const remove = (id) => {
  return request({
    url: '/api/produce/truck-transport-plan/delete',
    method: 'post',
    data: {
      id
    }
  })
}

export const audit = (id) => {
  return request({
      url: '/api/produce/truck-transport-plan/audit',
      method: 'get',
      params: {
          id
      }
  })
}

export const unAudit = (id) => {
  return request({
      url: '/api/produce/truck-transport-plan/unAudit',
      method: 'get',
      params: {
          id
      }
  })
}
